import type { ShareTarget } from "@/api/files-hub/fileShares.api";
import type { FileManagerItem } from "@/components/core/FileManager";
import type { FileManagerMount } from "@/components/features/FileManager/FileManagerMount";

export function itemShareTarget(
  mountType: FileManagerMount["type"],
  item: FileManagerItem,
): ShareTarget {
  return mountType === "sp-docs"
    ? { kind: "sp_document", documentId: item.id }
    : { kind: "item", fileId: item.id, ownDrive: mountType === "user" };
}
